import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "srev" }
const _hoisted_2 = {
  class: "sui-card srev__kpis",
  "data-tour": "seller-reviews-kpis",
  "aria-label": "리뷰·문의 요약"
}
const _hoisted_3 = { class: "srev__kpi srev__kpi--score" }
const _hoisted_4 = { class: "srev__score-value" }
const _hoisted_5 = { class: "srev__stars" }
const _hoisted_6 = { class: "srev__kpi-label" }
const _hoisted_7 = { class: "srev__kpi-dist" }
const _hoisted_8 = { class: "srev__dist" }
const _hoisted_9 = { class: "srev__kpi-value is-warn" }
const _hoisted_10 = { class: "srev__kpi-value is-warn" }
const _hoisted_11 = { class: "srev__kpi" }
const _hoisted_12 = { class: "srev__kpi-value" }
const _hoisted_13 = { class: "sui-card srev__toolbar-card" }
const _hoisted_14 = {
  class: "sui-toolbar srev__toolbar",
  "data-tour": "seller-reviews-toolbar"
}
const _hoisted_15 = {
  class: "sui-presets",
  role: "group",
  "aria-label": "기간"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "sui-date" }
const _hoisted_18 = { class: "sui-date" }
const _hoisted_19 = { class: "sui-search" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = {
  key: 0,
  class: "srev__chips"
}
const _hoisted_22 = { class: "srev__chip" }
const _hoisted_23 = {
  key: 1,
  class: "srev__error"
}
const _hoisted_24 = {
  class: "srev__mobile-tabs",
  role: "tablist"
}
const _hoisted_25 = {
  class: "srev__workbench",
  "data-tour": "seller-reviews-lanes"
}
const _hoisted_26 = { class: "srev__lane-head" }
const _hoisted_27 = { class: "srev__lane-filters" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "srev__lane-body" }
const _hoisted_30 = { class: "srev__queue" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "srev__row-top" }
const _hoisted_33 = ["title"]
const _hoisted_34 = {
  key: 0,
  class: "srev__delegate-chip",
  title: "관리자가 이 상담의 답변 권한을 판매업체에게 위임했습니다"
}
const _hoisted_35 = {
  key: 2,
  class: "srev__order-chip is-none"
}
const _hoisted_36 = {
  key: 4,
  class: "sui-badge sui-badge--gray"
}
const _hoisted_37 = { class: "srev__row-product" }
const _hoisted_38 = { class: "srev__row-preview" }
const _hoisted_39 = {
  key: 0,
  class: "srev__queue-empty"
}
const _hoisted_40 = {
  key: 0,
  class: "srev__detail"
}
const _hoisted_41 = { class: "srev__detail-head" }
const _hoisted_42 = {
  key: 0,
  class: "srev__delegate-chip"
}
const _hoisted_43 = { class: "srev__detail-product" }
const _hoisted_44 = { class: "srev__detail-body" }
const _hoisted_45 = {
  key: 0,
  class: "srev__reply"
}
const _hoisted_46 = { key: 0 }
const _hoisted_47 = {
  key: 0,
  class: "srev__consult-note is-delegated"
}
const _hoisted_48 = {
  class: "srev__templates",
  role: "group",
  "aria-label": "답변 템플릿"
}
const _hoisted_49 = ["onClick"]
const _hoisted_50 = ["placeholder"]
const _hoisted_51 = ["disabled"]
const _hoisted_52 = {
  key: 2,
  class: "srev__consult-note"
}
const _hoisted_53 = {
  key: 1,
  class: "srev__detail srev__detail--empty"
}
const _hoisted_54 = { class: "srev__lane-head" }
const _hoisted_55 = { class: "srev__lane-filters" }
const _hoisted_56 = ["onClick"]
const _hoisted_57 = { class: "srev__lane-body" }
const _hoisted_58 = { class: "srev__queue" }
const _hoisted_59 = ["onClick"]
const _hoisted_60 = { class: "srev__row-top" }
const _hoisted_61 = { class: "srev__row-stars" }
const _hoisted_62 = {
  key: 1,
  class: "srev__order-chip is-none"
}
const _hoisted_63 = { class: "srev__row-product" }
const _hoisted_64 = { class: "srev__row-preview" }
const _hoisted_65 = {
  key: 0,
  class: "srev__queue-empty"
}
const _hoisted_66 = {
  key: 0,
  class: "srev__detail"
}
const _hoisted_67 = { class: "srev__detail-head" }
const _hoisted_68 = { class: "srev__row-stars" }
const _hoisted_69 = { class: "srev__detail-product" }
const _hoisted_70 = { class: "srev__detail-body" }
const _hoisted_71 = {
  key: 0,
  class: "srev__reply"
}
const _hoisted_72 = {
  class: "srev__templates",
  role: "group",
  "aria-label": "답변 템플릿"
}
const _hoisted_73 = ["onClick"]
const _hoisted_74 = ["disabled"]
const _hoisted_75 = {
  key: 1,
  class: "srev__detail srev__detail--empty"
}
const _hoisted_76 = {
  key: 0,
  class: "sui-toast"
}

import { computed, onMounted, reactive, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import AppIcon from '@/components/common/AppIcon.vue'
import {
  answerSellerConsult,
  answerSellerQna,
  fetchSellerConsults,
  fetchSellerQnas,
  fetchSellerReviews,
  replySellerReview,
  type MallQna,
  type SellerMallReview,
  type SellerSharedConsult,
} from '@/api/mallReview'
import { useListDateRange } from '@/composables/useListDateRange'

interface InquiryEntry {
  /** ':for=key' 및 drafts 키 (원본 소스별로 유일) */
  key: string
  source: 'qna' | 'consult'
  idx: number
  orderCode: string
  productCode: string
  productName: string
  question: string
  answer: string
  answeredAt: string
  answeredBy: string
  date: string
  author: string
  org: string
  secret: boolean
  responseCount: number
  /**
   * 판매업체가 이 문의에 직접 답변할 수 있는가.
   * - source='qna' : 언제나 true (판매업체 소관)
   * - source='consult' : 관리자가 위임(ccr_seller_reply_allowed='Y') 한 경우에만 true
   */
  sellerCanReply: boolean
  /** 정렬용 원본 생성일 (YYYY-MM-DD HH:mm 또는 YYYY-MM-DD) */
  createdAt: string
}

const TEMPLATE_KEY = 'seller.reply.templates'


export default /*@__PURE__*/_defineComponent({
  __name: 'SellerReviewsPage',
  setup(__props) {

const route = useRoute()
const router = useRouter()

const reviews = ref<SellerMallReview[]>([])
const inquiries = ref<MallQna[]>([])
/**
 * 관리자 1:1 상담(caion_consult_req) 중 내가 판 주문에 걸린 항목.
 * 판매업체는 조회만 가능하고 답변은 관리자만 등록한다.
 */
const consults = ref<SellerSharedConsult[]>([])
const loading = ref(false)
const errorMessage = ref('')
const working = ref('')
const toast = ref('')
let toastTimer: ReturnType<typeof setTimeout> | undefined

const mobileTab = ref<'review' | 'inquiry'>('inquiry')
const focusLane = ref<'review' | 'inquiry' | null>(null)
const reviewFilter = ref<'all' | 'open' | 'done'>('all')
const inquiryFilter = ref<'all' | 'open' | 'done'>('open')
const keyword = ref('')
const productCode = ref('')
const drafts = reactive<Record<string, string>>({})
const selectedReviewId = ref('')
const selectedInquiryId = ref('')
const { fromDate, toDate, preset, presets, applyPreset, onManualDateChange, inRange } =
  useListDateRange('3m')

function applyRouteQuery() {
  const tab = String(route.query.tab || '')
  mobileTab.value = tab === 'review' ? 'review' : 'inquiry'
  focusLane.value = mobileTab.value

  const filter = String(route.query.filter || '')
  if (filter === 'open' || filter === 'done' || filter === 'all') {
    if (mobileTab.value === 'review') reviewFilter.value = filter
    else inquiryFilter.value = filter
  } else if (mobileTab.value === 'inquiry' && !route.query.filter) {
    inquiryFilter.value = 'open'
  }

  keyword.value = String(route.query.keyword || '').trim()
  productCode.value = String(route.query.productCode || route.query.product || '').trim()

  /*
   * 관리 주문 화면·알림·CS 링크에서 특정 주문번호·상품으로 좁혀 넘어오면 3개월 기본 필터에 걸려
   * 빈 화면이 뜰 수 있다. 필터 파라미터가 있으면 「전체」기간으로 자동 확장한다.
   */
  if (productCode.value || keyword.value) {
    applyPreset('all')
  }
}

applyRouteQuery()

watch(
  () => [route.query.tab, route.query.filter, route.query.keyword, route.query.productCode, route.query.product],
  () => {
    applyRouteQuery()
  },
)

const productFilterLabel = computed(() => {
  if (!productCode.value) return ''
  const fromReview = reviews.value.find((item) => item.productCode === productCode.value)
  if (fromReview) return fromReview.productName
  const fromInquiry = inquiries.value.find((item) => item.productCode === productCode.value)
  return fromInquiry?.productName || ''
})

/** 상품문의(QnA) + 1:1 상담(consult) 을 한 목록으로 병합해 문의 레인에 뿌린다. */
function toIsoDay(value: string | null | undefined) {
  return String(value || '').slice(0, 10)
}

function toIsoMinute(value: string | Date | null | undefined) {
  if (!value) return ''
  const raw = value instanceof Date ? value.toISOString() : String(value)
  return raw.replace('T', ' ').slice(0, 16)
}

/** 상품문의 → 통합 항목. 판매업체가 직접 답변 가능. */
function qnaToEntry(qna: MallQna): InquiryEntry {
  return {
    key: `qna:${qna.idx}`,
    source: 'qna',
    idx: qna.idx,
    orderCode: String(qna.orderCode || ''),
    productCode: qna.productCode,
    productName: qna.productName,
    question: qna.question,
    answer: qna.answer || '',
    answeredAt: qna.answeredAt || '',
    answeredBy: qna.answer ? '판매업체' : '',
    date: qna.date,
    author: qna.author,
    org: qna.org,
    secret: qna.secret,
    responseCount: qna.answer ? 1 : 0,
    sellerCanReply: true,
    createdAt: qna.date,
  }
}

/**
 * 1:1 상담 → 통합 항목.
 * 기본은 조회 전용이나, 관리자가 위임(consult.sellerReplyAllowed) 한 건은
 * 판매업체가 직접 답변할 수 있다. 이미 관리자 답변이 있는(답변완료) 상담도
 * 위임되면 추가 답변을 남길 수 있다. 위임 여부는 InquiryEntry.sellerCanReply 로 전달한다.
 */
function consultToEntry(consult: SellerSharedConsult): InquiryEntry {
  const question = consult.title
    ? `${consult.title}\n${consult.content}`.trim()
    : consult.content
  return {
    key: `consult:${consult.idx}`,
    source: 'consult',
    idx: consult.idx,
    orderCode: consult.orderCode,
    productCode: '',
    productName: consult.myItems || consult.title || '주문 상담',
    question,
    answer: consult.latestResponse || '',
    answeredAt: toIsoMinute(consult.latestResponseAt) || '',
    answeredBy: consult.latestResponse ? consult.latestResponseBy || '관리자' : '',
    date: toIsoDay(consult.createdAt),
    author: consult.authorId || '',
    org: consult.orgName || '',
    secret: false,
    responseCount: consult.responseCount || 0,
    sellerCanReply: Boolean(consult.sellerReplyAllowed),
    createdAt: toIsoMinute(consult.createdAt) || toIsoDay(consult.createdAt),
  }
}

/** 최신순으로 병합. 원본 생성 시각을 문자열 비교로 정렬한다. */
const mergedInquiries = computed<InquiryEntry[]>(() => {
  const list = [
    ...inquiries.value.map(qnaToEntry),
    ...consults.value.map(consultToEntry),
  ]
  return list.sort((a, b) => (a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0))
})

function clearProductFilter() {
  productCode.value = ''
  const query = { ...route.query }
  delete query.productCode
  delete query.product
  router.replace({ path: '/seller/reviews', query })
}

const laneFilters = [
  { key: 'open' as const, label: '대기' },
  { key: 'done' as const, label: '완료' },
  { key: 'all' as const, label: '전체' },
]

const DEFAULT_REPLY_TEMPLATES = [
  '소중한 후기 감사합니다. 더 좋은 상품으로 보답하겠습니다.',
  '이용해 주셔서 감사합니다. 추가 문의는 언제든 남겨 주세요.',
  '불편을 드려 죄송합니다. 개선하도록 하겠습니다.',
]
const DEFAULT_QNA_TEMPLATES = [
  '문의 감사합니다. 확인 후 안내드리겠습니다.',
  '재고 확인 중입니다. 곧 답변드리겠습니다.',
  '배송은 결제 완료 후 1~3영업일 내 출고됩니다.',
]

function loadTemplates(): { reply: string[]; qna: string[] } {
  try {
    const raw = localStorage.getItem(TEMPLATE_KEY)
    if (!raw) return { reply: DEFAULT_REPLY_TEMPLATES, qna: DEFAULT_QNA_TEMPLATES }
    const parsed = JSON.parse(raw) as { reply?: string[]; qna?: string[] }
    return {
      reply: Array.isArray(parsed.reply) && parsed.reply.length ? parsed.reply : DEFAULT_REPLY_TEMPLATES,
      qna: Array.isArray(parsed.qna) && parsed.qna.length ? parsed.qna : DEFAULT_QNA_TEMPLATES,
    }
  } catch {
    return { reply: DEFAULT_REPLY_TEMPLATES, qna: DEFAULT_QNA_TEMPLATES }
  }
}

const storedTemplates = loadTemplates()
const replyTemplates = ref(storedTemplates.reply)
const qnaTemplates = ref(storedTemplates.qna)

function applyTemplate(id: string, text: string) {
  const current = (drafts[id] || '').trim()
  drafts[id] = current ? `${current}\n${text}` : text
}

function focusOpenInquiries() {
  mobileTab.value = 'inquiry'
  inquiryFilter.value = 'open'
  focusLane.value = 'inquiry'
}

function focusOpenReviews() {
  mobileTab.value = 'review'
  reviewFilter.value = 'open'
  focusLane.value = 'review'
}

function selectInquiry(id: string) {
  selectedInquiryId.value = id
  focusLane.value = 'inquiry'
}

function selectReview(id: string) {
  selectedReviewId.value = id
  focusLane.value = 'review'
}

async function load() {
  loading.value = true
  errorMessage.value = ''
  try {
    /*
     * 상품문의(QnA)는 판매업체가 직접 답하고, 1:1 상담은 관리자가 답하지만
     * 판매업체도 「내가 판 주문에 걸린 상담」은 참고용으로 함께 보여 준다.
     */
    const [reviewList, qnaList, consultList] = await Promise.all([
      fetchSellerReviews(),
      fetchSellerQnas(),
      fetchSellerConsults().catch(() => [] as SellerSharedConsult[]),
    ])
    reviews.value = reviewList
    inquiries.value = qnaList
    consults.value = consultList
  } catch (error) {
    errorMessage.value = error instanceof Error ? error.message : '목록을 불러오지 못했습니다.'
    reviews.value = []
    inquiries.value = []
    consults.value = []
  } finally {
    loading.value = false
  }
}

onMounted(load)

const unrepliedReviews = computed(() => reviews.value.filter((review) => !review.reply).length)
/*
 * 판매업체가 실제로 답해야 하는 미답변 건 = 상품문의 미답변 + 관리자가 위임한 미답변 1:1 상담.
 * 관리자만 답변하는 (위임 안 된) 1:1 상담은 판매업체 몫이 아니므로 제외한다.
 */
const openInquiries = computed(
  () =>
    inquiries.value.filter((item) => !item.answer).length +
    consults.value.filter((item) => item.sellerReplyAllowed && !item.latestResponse).length,
)

const avgRating = computed(() => {
  if (!reviews.value.length) return '0.0'
  const sum = reviews.value.reduce((acc, review) => acc + review.rating, 0)
  return (sum / reviews.value.length).toFixed(1)
})

const distribution = computed(() =>
  [5, 4, 3, 2, 1].map((score) => {
    const count = reviews.value.filter((review) => review.rating === score).length
    return {
      score,
      count,
      percent: reviews.value.length ? Math.round((count / reviews.value.length) * 100) : 0,
    }
  }),
)

const filteredReviews = computed(() => {
  const query = keyword.value.toLowerCase()
  return reviews.value.filter((review) => {
    if (productCode.value && review.productCode !== productCode.value) return false
    if (!inRange(review.date)) return false
    if (reviewFilter.value === 'open' && review.reply) return false
    if (reviewFilter.value === 'done' && !review.reply) return false
    if (!query) return true
    return (
      review.productName.toLowerCase().includes(query) ||
      review.content.toLowerCase().includes(query) ||
      String(review.orderCode || '')
        .toLowerCase()
        .includes(query)
    )
  })
})

const filteredInquiries = computed(() => {
  const query = keyword.value.toLowerCase()
  return mergedInquiries.value.filter((inquiry) => {
    /*
     * 상품 필터는 상품문의(QnA) 에만 붙는다. 상담은 특정 상품이 아니라 주문 전체가 대상이라 항상 통과.
     * 답변 상태는 소스별로 정의가 다르다.
     *  - 상품문의: mpq_answer 유무
     *  - 1:1 상담: 관리자 응답(res) 유무
     */
    if (productCode.value && inquiry.source === 'qna' && inquiry.productCode !== productCode.value)
      return false
    if (productCode.value && inquiry.source === 'consult') return false
    if (!inRange(inquiry.date)) return false
    const isOpen = !inquiry.answer
    if (inquiryFilter.value === 'open' && !isOpen) return false
    if (inquiryFilter.value === 'done' && isOpen) return false
    if (!query) return true
    return (
      inquiry.productName.toLowerCase().includes(query) ||
      inquiry.question.toLowerCase().includes(query) ||
      String(inquiry.orderCode || '')
        .toLowerCase()
        .includes(query) ||
      inquiry.org.toLowerCase().includes(query)
    )
  })
})

const selectedReview = computed(
  () => filteredReviews.value.find((item) => item.id === selectedReviewId.value) || null,
)
const selectedInquiry = computed(
  () => filteredInquiries.value.find((item) => item.key === selectedInquiryId.value) || null,
)

watch(filteredReviews, (list) => {
  if (!list.length) {
    selectedReviewId.value = ''
    return
  }
  if (!list.some((item) => item.id === selectedReviewId.value)) {
    selectedReviewId.value = list[0].id
  }
})

watch(filteredInquiries, (list) => {
  if (!list.length) {
    selectedInquiryId.value = ''
    return
  }
  if (!list.some((item) => item.key === selectedInquiryId.value)) {
    selectedInquiryId.value = list[0].key
  }
})

function notify(message: string) {
  toast.value = message
  window.clearTimeout(toastTimer)
  toastTimer = setTimeout(() => {
    toast.value = ''
  }, 2400)
}

/*
 * 예전 SLA 뱃지 계산 훅 자리. 현재는 사용하지 않지만 템플릿에서 참조 중이라 빈 값을 돌려주는
 * 스텁으로 남겨 둔다. 미답변 문의의 대기 시간 등을 다시 시각화하고 싶으면 여기서 계산한다.
 */
function inquirySlaClass(_inquiry: InquiryEntry): string {
  return ''
}
function inquirySlaLabel(_inquiry: InquiryEntry): string {
  return ''
}

function canWriteInquiryReply(inquiry: InquiryEntry) {
  if (!inquiry.sellerCanReply) return false
  /* 상품문의는 답변 1회. 1:1 상담은 위임되면 답변완료 후에도 추가 등록 */
  if (inquiry.source === 'qna') return !inquiry.answer
  return true
}

function inquiryReplyPlaceholder(inquiry: InquiryEntry) {
  if (inquiry.source === 'consult') {
    return inquiry.answer
      ? '추가 답변을 작성하세요. 기존 답변 아래에 이어지고, 관리자에게도 공유됩니다.'
      : '상담 답변 내용을 작성하세요. 관리자에게도 함께 공유됩니다.'
  }
  return '문의에 대한 답변을 작성하세요.'
}

/* 템플릿 관리 다이얼로그는 아직 붙지 않았다. 눌렀을 때 안내 토스트만 띄운다. */
function openTemplates() {
  notify('답변 템플릿은 아래 답변란에서 직접 수정해 저장할 수 있습니다.')
}

async function submitReply(review: SellerMallReview) {
  const text = drafts[review.id]?.trim()
  if (!text || working.value) return
  if (!window.confirm('후기 답변을 등록할까요?')) return

  working.value = review.id
  try {
    await replySellerReview(review.idx, text)
    review.reply = text
    review.repliedAt = new Date().toISOString().slice(0, 16).replace('T', ' ')
    drafts[review.id] = ''
    notify('후기 답변을 등록했습니다.')
  } catch (error) {
    notify(error instanceof Error ? error.message : '답변 등록에 실패했습니다.')
  } finally {
    working.value = ''
  }
}

async function submitAnswer(inquiry: InquiryEntry) {
  /* 1:1 상담 중 위임되지 않은 건 판매업체가 답할 수 없다. */
  if (!inquiry.sellerCanReply) {
    notify('1:1 상담 답변은 함우리몰 관리자가 대신 처리합니다.')
    return
  }
  const text = drafts[inquiry.key]?.trim()
  if (!text || working.value) return
  const confirmMessage =
    inquiry.source === 'consult'
      ? inquiry.answer
        ? '이 1:1 상담에 추가 답변을 등록할까요? 기존 답변은 그대로 두고, 관리자에게도 공유됩니다.'
        : '이 1:1 상담에 판매자 답변으로 등록할까요? 관리자에게도 공유됩니다.'
      : '문의 답변을 등록할까요?'
  if (!window.confirm(confirmMessage)) return

  working.value = inquiry.key
  try {
    if (inquiry.source === 'qna') {
      await answerSellerQna(inquiry.idx, text)
      /* 원본 배열도 즉시 갱신해서 mergedInquiries 재계산이 반영되게 한다. */
      const raw = inquiries.value.find((item) => item.idx === inquiry.idx)
      if (raw) {
        raw.answer = text
        raw.answeredAt = new Date().toISOString().slice(0, 16).replace('T', ' ')
      }
    } else {
      await answerSellerConsult(inquiry.idx, text)
      const raw = consults.value.find((item) => item.idx === inquiry.idx)
      if (raw) {
        raw.latestResponse = text
        raw.latestResponseAt = new Date().toISOString()
        raw.latestResponseBy = '판매업체'
        raw.responseCount = (raw.responseCount || 0) + 1
        raw.status = 'DONE'
      }
    }
    drafts[inquiry.key] = ''
    notify(inquiry.source === 'consult' ? '상담 답변을 등록했습니다.' : '문의 답변을 등록했습니다.')
  } catch (error) {
    notify(error instanceof Error ? error.message : '답변 등록에 실패했습니다.')
  } finally {
    working.value = ''
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(avgRating.value), 1),
        _createElementVNode("p", _hoisted_5, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (star) => {
            return _createVNode(AppIcon, {
              key: star,
              icon: star <= Math.round(Number(avgRating.value)) ? 'mdi-star' : 'mdi-star-outline',
              size: 15
            }, null, 8, ["icon"])
          }), 64))
        ]),
        _createElementVNode("p", _hoisted_6, "평균 별점 · 후기 " + _toDisplayString(reviews.value.length), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("ul", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(distribution.value, (row) => {
            return (_openBlock(), _createElementBlock("li", {
              key: row.score
            }, [
              _createElementVNode("span", null, _toDisplayString(row.score), 1),
              _createElementVNode("em", null, [
                _createElementVNode("i", {
                  style: _normalizeStyle({ width: `${row.percent}%` })
                }, null, 4)
              ]),
              _createElementVNode("b", null, _toDisplayString(row.count), 1)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["srev__kpi", { 'is-active': focusLane.value === 'inquiry' && inquiryFilter.value === 'open' }]),
        onClick: focusOpenInquiries
      }, [
        _createElementVNode("p", _hoisted_9, [
          _createTextVNode(_toDisplayString(openInquiries.value), 1),
          _cache[13] || (_cache[13] = _createElementVNode("em", null, "건", -1))
        ]),
        _cache[14] || (_cache[14] = _createElementVNode("p", { class: "srev__kpi-label" }, "미답변 문의", -1))
      ], 2),
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["srev__kpi", { 'is-active': focusLane.value === 'review' && reviewFilter.value === 'open' }]),
        onClick: focusOpenReviews
      }, [
        _createElementVNode("p", _hoisted_10, [
          _createTextVNode(_toDisplayString(unrepliedReviews.value), 1),
          _cache[15] || (_cache[15] = _createElementVNode("em", null, "건", -1))
        ]),
        _cache[16] || (_cache[16] = _createElementVNode("p", { class: "srev__kpi-label" }, "답변 대기 후기", -1))
      ], 2),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("p", _hoisted_12, [
          _createTextVNode(_toDisplayString(mergedInquiries.value.length), 1),
          _cache[17] || (_cache[17] = _createElementVNode("em", null, "건", -1))
        ]),
        _cache[18] || (_cache[18] = _createElementVNode("p", { class: "srev__kpi-label" }, "전체 문의", -1))
      ])
    ]),
    _createElementVNode("section", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(presets), (item) => {
            return (_openBlock(), _createElementBlock("button", {
              key: item.key,
              type: "button",
              class: _normalizeClass({ 'is-active': _unref(preset) === item.key }),
              onClick: ($event: any) => (_unref(applyPreset)(item.key))
            }, _toDisplayString(item.label), 11, _hoisted_16))
          }), 128))
        ]),
        _createElementVNode("label", _hoisted_17, [
          _cache[19] || (_cache[19] = _createElementVNode("span", null, "시작일", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(fromDate) ? (fromDate).value = $event : null)),
            type: "date",
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(onManualDateChange) && _unref(onManualDateChange)(...args)))
          }, null, 544), [
            [_vModelText, _unref(fromDate)]
          ])
        ]),
        _createElementVNode("label", _hoisted_18, [
          _cache[20] || (_cache[20] = _createElementVNode("span", null, "종료일", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(toDate) ? (toDate).value = $event : null)),
            type: "date",
            onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(onManualDateChange) && _unref(onManualDateChange)(...args)))
          }, null, 544), [
            [_vModelText, _unref(toDate)]
          ])
        ]),
        _createElementVNode("label", _hoisted_19, [
          _createVNode(AppIcon, {
            icon: "mdi-magnify",
            size: 17
          }),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((keyword).value = $event)),
            type: "search",
            placeholder: "상품명 · 주문번호 · 내용 검색"
          }, null, 512), [
            [
              _vModelText,
              keyword.value,
              void 0,
              { trim: true }
            ]
          ])
        ]),
        _cache[23] || (_cache[23] = _createElementVNode("span", { class: "sui-toolbar__spacer" }, null, -1)),
        _createElementVNode("button", {
          type: "button",
          class: "sui-btn",
          "data-tour": "seller-reviews-templates",
          onClick: openTemplates
        }, [
          _createVNode(AppIcon, {
            icon: "mdi-text-box-edit-outline",
            size: 16
          }),
          _cache[21] || (_cache[21] = _createTextVNode(" 템플릿 관리 ", -1))
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "sui-btn",
          disabled: loading.value,
          onClick: load
        }, [
          _createVNode(AppIcon, {
            icon: "mdi-refresh",
            size: 16
          }),
          _cache[22] || (_cache[22] = _createTextVNode(" 새로고침 ", -1))
        ], 8, _hoisted_20)
      ]),
      (productCode.value || productFilterLabel.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createElementVNode("span", _hoisted_22, [
              _cache[24] || (_cache[24] = _createTextVNode(" 상품 필터 ", -1)),
              _createElementVNode("strong", null, _toDisplayString(productFilterLabel.value || productCode.value), 1),
              _createElementVNode("button", {
                type: "button",
                "aria-label": "상품 필터 해제",
                onClick: clearProductFilter
              }, [
                _createVNode(AppIcon, {
                  icon: "mdi-close",
                  size: 14
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (errorMessage.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_23, [
            _createVNode(AppIcon, {
              icon: "mdi-alert-outline",
              size: 16
            }),
            _createTextVNode(" " + _toDisplayString(errorMessage.value), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("button", {
        type: "button",
        role: "tab",
        class: _normalizeClass(["srev__mobile-tab", { 'is-active': mobileTab.value === 'inquiry' }]),
        onClick: _cache[5] || (_cache[5] = ($event: any) => (mobileTab.value = 'inquiry'))
      }, [
        _cache[25] || (_cache[25] = _createTextVNode(" 상품 문의 ", -1)),
        _createElementVNode("em", null, _toDisplayString(filteredInquiries.value.length), 1)
      ], 2),
      _createElementVNode("button", {
        type: "button",
        role: "tab",
        class: _normalizeClass(["srev__mobile-tab", { 'is-active': mobileTab.value === 'review' }]),
        onClick: _cache[6] || (_cache[6] = ($event: any) => (mobileTab.value = 'review'))
      }, [
        _cache[26] || (_cache[26] = _createTextVNode(" 상품 후기 ", -1)),
        _createElementVNode("em", null, _toDisplayString(filteredReviews.value.length), 1)
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("section", {
        class: _normalizeClass(["sui-card srev__lane", { 'is-hidden-mobile': mobileTab.value !== 'inquiry' }])
      }, [
        _createElementVNode("header", _hoisted_26, [
          _createElementVNode("h2", null, [
            _cache[27] || (_cache[27] = _createTextVNode(" 상품 문의 ", -1)),
            _createElementVNode("em", null, _toDisplayString(filteredInquiries.value.length), 1)
          ]),
          _createElementVNode("div", _hoisted_27, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(laneFilters, (opt) => {
              return _createElementVNode("button", {
                key: `q-${opt.key}`,
                type: "button",
                class: _normalizeClass({ 'is-active': inquiryFilter.value === opt.key }),
                onClick: ($event: any) => (inquiryFilter.value = opt.key)
              }, _toDisplayString(opt.label), 11, _hoisted_28)
            }), 64))
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("ul", _hoisted_30, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredInquiries.value, (inquiry) => {
              return (_openBlock(), _createElementBlock("li", {
                key: inquiry.key,
                class: _normalizeClass(["srev__row", [
                inquirySlaClass(inquiry),
                { 'is-selected': selectedInquiryId.value === inquiry.key, 'is-open': !inquiry.answer },
              ]]),
                onClick: ($event: any) => (selectInquiry(inquiry.key))
              }, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["sui-badge", inquiry.answer ? 'sui-badge--green' : 'sui-badge--red'])
                  }, _toDisplayString(inquiry.answer ? '완료' : '미답변'), 3),
                  _createElementVNode("span", {
                    class: _normalizeClass(["srev__source-chip", `is-${inquiry.source}`]),
                    title: inquiry.source === 'consult' ? (inquiry.sellerCanReply ? '관리자가 답변 권한을 위임한 1:1 상담. 판매업체가 직접 답변할 수 있습니다.' : '관리자가 답변하는 1:1 상담. 판매업체는 조회만 합니다.') : '판매업체가 직접 답변하는 상품문의'
                  }, _toDisplayString(inquiry.source === 'consult' ? '1:1 상담' : '상품문의'), 11, _hoisted_33),
                  (inquiry.source === 'consult' && inquiry.sellerCanReply)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_34, [
                        _createVNode(AppIcon, {
                          icon: "mdi-shield-check-outline",
                          size: 12
                        }),
                        _cache[28] || (_cache[28] = _createTextVNode(" 답변 위임 ", -1))
                      ]))
                    : _createCommentVNode("", true),
                  (inquiry.orderCode)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 1,
                        class: "srev__order-chip",
                        to: { path: '/seller/orders', query: { keyword: inquiry.orderCode } },
                        title: `${inquiry.orderCode} 주문으로 이동`,
                        onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(inquiry.orderCode), 1)
                        ]),
                        _: 2
                      }, 1032, ["to", "title"]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_35, "일반 문의")),
                  (inquirySlaLabel(inquiry))
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 3,
                        class: _normalizeClass(["srev__sla", inquirySlaClass(inquiry)])
                      }, _toDisplayString(inquirySlaLabel(inquiry)), 3))
                    : _createCommentVNode("", true),
                  (inquiry.secret)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_36, "비밀"))
                    : _createCommentVNode("", true),
                  _createElementVNode("time", null, _toDisplayString(inquiry.date), 1)
                ]),
                _createElementVNode("p", _hoisted_37, _toDisplayString(inquiry.productName), 1),
                _createElementVNode("p", _hoisted_38, _toDisplayString(inquiry.question), 1)
              ], 10, _hoisted_31))
            }), 128)),
            (!filteredInquiries.value.length)
              ? (_openBlock(), _createElementBlock("li", _hoisted_39, _toDisplayString(loading.value ? '불러오는 중…' : '조건에 맞는 문의가 없습니다.'), 1))
              : _createCommentVNode("", true)
          ]),
          (selectedInquiry.value)
            ? (_openBlock(), _createElementBlock("aside", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["sui-badge", selectedInquiry.value.answer ? 'sui-badge--green' : 'sui-badge--red'])
                  }, _toDisplayString(selectedInquiry.value.answer ? '답변 완료' : '미답변'), 3),
                  _createElementVNode("span", {
                    class: _normalizeClass(["srev__source-chip", `is-${selectedInquiry.value.source}`])
                  }, _toDisplayString(selectedInquiry.value.source === 'consult'
                    ? selectedInquiry.value.sellerCanReply
                      ? '1:1 상담 (답변 위임)'
                      : '1:1 상담 (관리자 응대)'
                    : '상품문의'), 3),
                  (selectedInquiry.value.source === 'consult' && selectedInquiry.value.sellerCanReply)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_42, [
                        _createVNode(AppIcon, {
                          icon: "mdi-shield-check-outline",
                          size: 12
                        }),
                        _cache[29] || (_cache[29] = _createTextVNode(" 답변 위임 ", -1))
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", null, _toDisplayString(selectedInquiry.value.author || '작성자') + " · " + _toDisplayString(selectedInquiry.value.org) + " · " + _toDisplayString(selectedInquiry.value.date), 1)
                ]),
                _createElementVNode("p", _hoisted_43, _toDisplayString(selectedInquiry.value.productName), 1),
                _createElementVNode("p", _hoisted_44, _toDisplayString(selectedInquiry.value.question), 1),
                (selectedInquiry.value.answer)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                      _createVNode(AppIcon, {
                        icon: "mdi-subdirectory-arrow-right",
                        size: 16
                      }),
                      _createElementVNode("p", null, [
                        _createTextVNode(_toDisplayString(selectedInquiry.value.answer) + " ", 1),
                        (selectedInquiry.value.answeredAt)
                          ? (_openBlock(), _createElementBlock("em", _hoisted_46, [
                              _createTextVNode(_toDisplayString(selectedInquiry.value.answeredAt) + " ", 1),
                              (selectedInquiry.value.answeredBy)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(" · " + _toDisplayString(selectedInquiry.value.answeredBy), 1)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (canWriteInquiryReply(selectedInquiry.value))
                  ? (_openBlock(), _createElementBlock("form", {
                      key: 1,
                      class: "srev__form",
                      onSubmit: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (submitAnswer(selectedInquiry.value)), ["prevent"]))
                    }, [
                      (selectedInquiry.value.source === 'consult')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_47, [
                            _createVNode(AppIcon, {
                              icon: "mdi-shield-check-outline",
                              size: 16
                            }),
                            _createTextVNode(" " + _toDisplayString(selectedInquiry.value.answer
                    ? '관리자가 답변 권한을 위임했습니다. 이미 답변이 있어도 추가로 남길 수 있고, 「판매자」로 기록됩니다.'
                    : '관리자가 이 1:1 상담의 답변 권한을 위임했습니다. 답변은 즉시 상담 스레드에 「판매자」로 기록됩니다.'), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_48, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(qnaTemplates.value, (tpl) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: `q-${tpl}`,
                            type: "button",
                            class: "srev__tpl",
                            onClick: ($event: any) => (applyTemplate(selectedInquiry.value.key, tpl))
                          }, _toDisplayString(tpl), 9, _hoisted_49))
                        }), 128)),
                        _createElementVNode("button", {
                          type: "button",
                          class: "srev__tpl srev__tpl--manage",
                          onClick: openTemplates
                        }, " 템플릿 관리 ")
                      ]),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((drafts[selectedInquiry.value.key]) = $event)),
                        class: "sui-input srev__textarea",
                        rows: "5",
                        placeholder: inquiryReplyPlaceholder(selectedInquiry.value)
                      }, null, 8, _hoisted_50), [
                        [
                          _vModelText,
                          drafts[selectedInquiry.value.key],
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      _createElementVNode("button", {
                        type: "submit",
                        class: "sui-btn sui-btn--primary",
                        disabled: !drafts[selectedInquiry.value.key] || working.value === selectedInquiry.value.key
                      }, _toDisplayString(working.value === selectedInquiry.value.key
                    ? '등록 중…'
                    : selectedInquiry.value.source === 'consult' && selectedInquiry.value.answer
                      ? '추가 답변 등록'
                      : '답변 등록'), 9, _hoisted_51)
                    ], 32))
                  : (selectedInquiry.value.source === 'consult' && !selectedInquiry.value.answer)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_52, [
                        _createVNode(AppIcon, {
                          icon: "mdi-information-outline",
                          size: 16
                        }),
                        _cache[30] || (_cache[30] = _createTextVNode(" 1:1 상담은 함우리몰 관리자가 대신 응대합니다. 판매업체는 참고 목적으로 열람만 가능하고, 답변이 필요하면 관리자에게 위임을 요청해 주세요. ", -1))
                      ]))
                    : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("aside", _hoisted_53, [
                _createVNode(AppIcon, {
                  icon: "mdi-forum-outline",
                  size: 36
                }),
                _cache[31] || (_cache[31] = _createElementVNode("p", null, [
                  _createTextVNode("왼쪽에서 문의를 선택하면"),
                  _createElementVNode("br"),
                  _createTextVNode("여기에서 답변합니다.")
                ], -1))
              ]))
        ])
      ], 2),
      _createElementVNode("section", {
        class: _normalizeClass(["sui-card srev__lane", { 'is-hidden-mobile': mobileTab.value !== 'review' }])
      }, [
        _createElementVNode("header", _hoisted_54, [
          _createElementVNode("h2", null, [
            _cache[32] || (_cache[32] = _createTextVNode(" 상품 후기 ", -1)),
            _createElementVNode("em", null, _toDisplayString(filteredReviews.value.length), 1)
          ]),
          _createElementVNode("div", _hoisted_55, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(laneFilters, (opt) => {
              return _createElementVNode("button", {
                key: `r-${opt.key}`,
                type: "button",
                class: _normalizeClass({ 'is-active': reviewFilter.value === opt.key }),
                onClick: ($event: any) => (reviewFilter.value = opt.key)
              }, _toDisplayString(opt.label), 11, _hoisted_56)
            }), 64))
          ])
        ]),
        _createElementVNode("div", _hoisted_57, [
          _createElementVNode("ul", _hoisted_58, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredReviews.value, (review) => {
              return (_openBlock(), _createElementBlock("li", {
                key: review.id,
                class: _normalizeClass(["srev__row", { 'is-selected': selectedReviewId.value === review.id, 'is-open': !review.reply }]),
                onClick: ($event: any) => (selectReview(review.id))
              }, [
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("span", _hoisted_61, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (star) => {
                      return _createVNode(AppIcon, {
                        key: star,
                        icon: star <= review.rating ? 'mdi-star' : 'mdi-star-outline',
                        size: 12
                      }, null, 8, ["icon"])
                    }), 64))
                  ]),
                  _createElementVNode("span", {
                    class: _normalizeClass(["sui-badge", review.reply ? 'sui-badge--green' : 'sui-badge--amber'])
                  }, _toDisplayString(review.reply ? '완료' : '대기'), 3),
                  (review.orderCode)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        class: "srev__order-chip",
                        to: { path: '/seller/orders', query: { keyword: review.orderCode } },
                        title: `${review.orderCode} 주문으로 이동`,
                        onClick: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"]))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(review.orderCode), 1)
                        ]),
                        _: 2
                      }, 1032, ["to", "title"]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_62, "주문 없음")),
                  _createElementVNode("time", null, _toDisplayString(review.date), 1)
                ]),
                _createElementVNode("p", _hoisted_63, _toDisplayString(review.productName), 1),
                _createElementVNode("p", _hoisted_64, _toDisplayString(review.content), 1)
              ], 10, _hoisted_59))
            }), 128)),
            (!filteredReviews.value.length)
              ? (_openBlock(), _createElementBlock("li", _hoisted_65, _toDisplayString(loading.value ? '불러오는 중…' : '조건에 맞는 후기가 없습니다.'), 1))
              : _createCommentVNode("", true)
          ]),
          (selectedReview.value)
            ? (_openBlock(), _createElementBlock("aside", _hoisted_66, [
                _createElementVNode("div", _hoisted_67, [
                  _createElementVNode("span", _hoisted_68, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (star) => {
                      return _createVNode(AppIcon, {
                        key: star,
                        icon: star <= selectedReview.value.rating ? 'mdi-star' : 'mdi-star-outline',
                        size: 14
                      }, null, 8, ["icon"])
                    }), 64))
                  ]),
                  _createElementVNode("p", null, _toDisplayString(selectedReview.value.author) + " · " + _toDisplayString(selectedReview.value.org) + " · " + _toDisplayString(selectedReview.value.date), 1)
                ]),
                _createElementVNode("p", _hoisted_69, _toDisplayString(selectedReview.value.productName), 1),
                _createElementVNode("p", _hoisted_70, _toDisplayString(selectedReview.value.content), 1),
                (selectedReview.value.reply)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                      _createVNode(AppIcon, {
                        icon: "mdi-subdirectory-arrow-right",
                        size: 16
                      }),
                      _createElementVNode("p", null, _toDisplayString(selectedReview.value.reply), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("form", {
                      key: 1,
                      class: "srev__form",
                      onSubmit: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (submitReply(selectedReview.value)), ["prevent"]))
                    }, [
                      _createElementVNode("div", _hoisted_72, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(replyTemplates.value, (tpl) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: `r-${tpl}`,
                            type: "button",
                            class: "srev__tpl",
                            onClick: ($event: any) => (applyTemplate(selectedReview.value.id, tpl))
                          }, _toDisplayString(tpl), 9, _hoisted_73))
                        }), 128)),
                        _createElementVNode("button", {
                          type: "button",
                          class: "srev__tpl srev__tpl--manage",
                          onClick: openTemplates
                        }, " 템플릿 관리 ")
                      ]),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((drafts[selectedReview.value.id]) = $event)),
                        class: "sui-input srev__textarea",
                        rows: "5",
                        placeholder: "구매 기관에 남길 답변을 작성하세요."
                      }, null, 512), [
                        [
                          _vModelText,
                          drafts[selectedReview.value.id],
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      _createElementVNode("button", {
                        type: "submit",
                        class: "sui-btn sui-btn--primary",
                        disabled: !drafts[selectedReview.value.id] || working.value === selectedReview.value.id
                      }, _toDisplayString(working.value === selectedReview.value.id ? '등록 중…' : '답변 등록'), 9, _hoisted_74)
                    ], 32))
              ]))
            : (_openBlock(), _createElementBlock("aside", _hoisted_75, [
                _createVNode(AppIcon, {
                  icon: "mdi-comment-outline",
                  size: 36
                }),
                _cache[33] || (_cache[33] = _createElementVNode("p", null, [
                  _createTextVNode("왼쪽에서 후기를 선택하면"),
                  _createElementVNode("br"),
                  _createTextVNode("여기에서 답변합니다.")
                ], -1))
              ]))
        ])
      ], 2)
    ]),
    _createVNode(_Transition, { name: "sui-toast" }, {
      default: _withCtx(() => [
        (toast.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_76, [
              _createVNode(AppIcon, {
                icon: "mdi-check-circle",
                size: 18
              }),
              _createTextVNode(" " + _toDisplayString(toast.value), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})